module.exports = __webpack_public_path__ + "static/img/duffy-thomas.c21e9a2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/duffy-thomas.jpg
// module id = 1WlF
// module chunks = 0